<mh-alerts-wrapper>
  <section mhFilterBar>
    <div mhFilterGroup>
      <mh-core-lib-datepicker
        [currentDates]="currentDates"
        [currentFilter]="currentFilterDate"
        (datepickerUpdated)="handleDatepickerUpdated($event)">
      </mh-core-lib-datepicker>
      <mh-box-element *ngIf="fidelityPermissions.includes('interchain_online_summary_result')">
        <mh-core-lib-filter-chain-zone [productId]="productId" [multipleSelectionMode]="true" (chainChanged)="setChain($event)"
          [disabled]="!isReady"></mh-core-lib-filter-chain-zone>
      </mh-box-element>
      <mh-core-lib-filter-hotels [chainFilter]="originalChainFilter" [multipleSelectionMode]="true" (hotelsChanged)="setHotelsFilter($event)"
        [disabled]="isHotelsFilterDisabled"></mh-core-lib-filter-hotels>
    </div>
  </section>

  <ng-container *ngIf="shouldShowSummary">
    <mh-inter-chain-online-summary 
      [productId]="productId"
      [chain]="chainFilter"
      [currentDates]="currentDates">
    </mh-inter-chain-online-summary>
  </ng-container>
</mh-alerts-wrapper>
